// export * as components from './components/index.js'
import colors from './scss/colors.module.scss'
import { h } from 'vue'

export const config = {
  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
    themes: {
      light: {
        dark: false,
        colors: colors,
      },
      dark: {
        dark: true,
        colors: colors,
      },
    },
  },
  display: {
    mobileBreakpoint: 'sm',
  },
  defaults: {
    global: {
      ripple: false,
    },
  },
  icons: {
    defaultSet: 'icon',
    sets: {
      icon: {
        component: (props) => h(props.tag, { class: ['icon', props.icon] }),
      },
    },
  },
}
